export const getAvailableDayEvents = availables => {
    const availableDays = [];

    if (availables?.length > 0) {
        availables.forEach(opening => {
            if (!opening.IsRestDay) {
                availableDays.push({
                    title: 'Available',
                    allDay: false,
                    classNames: 'tw-block',
                    textColor: '#ffffff',
                    daysOfWeek: [opening.Day - 1],
                    startTime: opening.StartTime,
                    endTime: opening.EndTime,
                    extendedProps: {
                        type: 'available'
                    }
                });
            }
        });
    } else {
        // work 24/7
        [2, 3, 4, 5, 6, 7, 1].forEach(Day => {
            availableDays.push({
                title: 'Available',
                allDay: true,
                classNames: 'tw-block',
                textColor: '#ffffff',
                daysOfWeek: [Day - 1],
                startTime: '00:00:00',
                endTime: '23:59:59',
                extendedProps: {
                    type: 'available'
                }
            });
        });
    }

    return availableDays;
};
